/* eslint-disable */

import { otherPublicationEndpoint, publicaitonEndpoint } from './patterns/endpoints';
import { clearHtml, createCongressEl, createPublicationEl, resultCounter, returnToSearch, zeroResults } from './patterns/dynamic-html';
import { sortDesc } from './patterns/sort-util';
import { loadMore } from './patterns/load-more.utils';

window.addEventListener('load', () => {

    const selector = /^\/?peer-reviewed-publications\/?$/.test(window.location.pathname) ? '.publications' : '.other-publications';
    const openModal = selector === '.publications';

    if (document.querySelector(selector)) {

        //Handle <strong>Return to search</strong> past/upcoming
        returnToSearch('.publication__return-to-search', '.search-label--publications');

        //Fetch data
        fetch(selector === '.publications' ? publicaitonEndpoint : otherPublicationEndpoint)
            .then(response => response.json())
            .then(data => {
                if(data.success !== true) {
                    document.querySelector(`${selector} .processing-error.error`).classList.add('show');
                }
                else {
                    const publicationWrapper = document.querySelector('.publication-wrapper');
                    const publicationData = sortDesc(data.data.publication, 'dateUnformatted');
    
                    //Remove loading icon
                    document.querySelector(`${selector}.container`).setAttribute('data-loading', 'false');

                    //Populate publications
                    publicationData.map((p, index) => {
                        publicationWrapper.appendChild(createPublicationEl(p, index, openModal));
                    });
    
                    //Populate results counter past/upcoming
                    resultCounter(publicationData, '.publication__counter span');
    
                    //Handle load more for past/upcoming congresses
                    loadMore('.publication[hidden]', 5, '.load-more--publication');

                    //Show controls
                    document.querySelector('.congress-publication-bottom-controls[hidden]').hidden = false;

                    //Add modal handler
                    if(document.querySelectorAll('.publication__url a[data-component="modal"]').length > 0 && openModal) {
                        document.querySelectorAll('.publication__url a[data-component="modal"]').forEach(a => {
                            a.addEventListener('click', e => {
                                e.preventDefault();
                                const targetUrl = e.target.href;
                                document.querySelector('#exit-modal a.modal__continue').href = targetUrl;
                            });
                        });
                    }
    
                    //Filter data using dropdowns
                    document.getElementById('categoryPublication').addEventListener('input', (e) => {
                        //Clear filter
                        let filters = {
                            'category': '',
                        };
    
                        //Clear current results
                        clearHtml(publicationWrapper);
                        //Add loading icon back
                        document.querySelector(`${selector}.container`).setAttribute('data-loading', 'true');
    
                        //Create new filter
                        filters.category = document.getElementById('categoryPublication').value;
    
                        const filteredPublicationData = publicationData.filter(a => {
                            return filters.category === 'All Categories' ? a.category === a.category : a.category === filters.category;
                        });
    
                        //Remove loading icon
                        document.querySelector(`${selector}.container`).setAttribute('data-loading', 'false');
    
                        //Show message if there are no results
                        zeroResults(filteredPublicationData, '.publication__zero-results', '.publication__return-to-search');
    
                        //Pupulater new results
                        filteredPublicationData.map((c, index) => {
                            publicationWrapper.appendChild(createPublicationEl(c, index, openModal));
                        });
    
                        //Populate results counter past
                        resultCounter(filteredPublicationData, '.publication__counter span');
    
                        //Handle load more after filtering
                        if(document.querySelectorAll('.publication[hidden]').length > 0) {
                            document.querySelector('.load-more--publication').hidden = false;
                        } else {
                            document.querySelector('.load-more--publication').hidden = true;
                        }

                        //Add modal handler
                        if(document.querySelectorAll('.publication__url a').length > 0 && openModal) {
                            document.querySelectorAll('.publication__url a').forEach(a => {
                                a.addEventListener('click', e => {
                                    e.preventDefault();
                                    const targetUrl = e.target.href;
                                    document.querySelector('#exit-modal a.modal__continue').href = targetUrl;
                                });
                            });
                        }
                    })
                }
            });
    }
})
